import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import api from '../../services/api';

function formatDate(dateStr) {
  if (!dateStr) return null;
  return new Date(dateStr).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
}

function CancelConfirmModal({ subscription, onClose, onCancelled }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const isFamily = subscription.allowsFamily;
  const downgradeDate = subscription.periodEnd ? formatDate(subscription.periodEnd) : 'the end of your billing period';

  const handleCancel = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await api.post('/subscriptions/cancel');
      onCancelled(response.data);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to cancel. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return ReactDOM.createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: '460px' }}>
        <div className="modal-header">
          <h3>Cancel Subscription?</h3>
          <button onClick={onClose}>&#10005;</button>
        </div>
        <div style={{ padding: '1.5rem' }}>
          <p style={{ marginBottom: '0.75rem' }}>
            After cancelling, you'll move to the <strong>Free tier</strong> on <strong>{downgradeDate}</strong>.
          </p>

          <div style={{ background: '#fef2f2', borderRadius: '6px', padding: '0.75rem 1rem', marginBottom: '0.75rem', fontSize: '0.875em' }}>
            <strong>You'll lose access to:</strong>
            <ul style={{ marginTop: '0.4rem', paddingLeft: '1.25rem' }}>
              <li>Export and download of reflections</li>
              <li>Sending sharing invitations</li>
              {isFamily && <li>Family archive and member accounts (members get 30-day grace period)</li>}
              <li>Creating reflections beyond the free limit of 10</li>
            </ul>
          </div>

          <p style={{ fontSize: '0.875em', opacity: 0.8, marginBottom: '1.25rem' }}>
            All your existing reflections remain safe and accessible regardless of plan.
          </p>

          {error && <p style={{ color: 'red', marginBottom: '0.75rem', fontSize: '0.875em' }}>{error}</p>}

          <div style={{ display: 'flex', gap: '0.75rem' }}>
            <button className="btn-save" onClick={onClose} style={{ flex: 1 }}>
              Keep my plan
            </button>
            <button
              onClick={handleCancel}
              disabled={loading}
              style={{
                flex: 1, padding: '0.5rem 1rem',
                background: '#e53e3e', color: '#fff',
                border: 'none', borderRadius: '6px', cursor: 'pointer',
                opacity: loading ? 0.6 : 1,
              }}
            >
              {loading ? 'Cancelling…' : 'Yes, cancel'}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default CancelConfirmModal;
